import angular from 'angular';
import ActiveAnnouncementsComponent from './active-announcements-component';

export default angular.module('active-announcements', []).component('activeAnnouncements', new ActiveAnnouncementsComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/announcements/components/active-announcements/active-announcements-module.js